export default "__VITE_ASSET__BSKnEsZZ__"